var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6341_7032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.95248C0.0660324 1.74158 0.132676 1.53067 0.218274 1.25781C2.73117 3.88253 5.21167 6.47282 7.63225 9.00115C5.22023 11.5195 2.73484 14.1135 0.217662 16.742C0.132065 16.4704 0.0660324 16.2595 0 16.0486C0 11.3499 0 6.65118 0 1.95248Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24219 0.192455C1.54789 0.124866 1.81141 0.0610314 2.07738 0.0103395C2.17214 -0.00780942 2.27242 0.00345545 2.36963 0.00345545C9.12328 0.00345545 15.8763 0.00345545 22.63 0.0022038C23.006 0.0022038 23.3704 0.0428825 23.7256 0.231882C23.6608 0.3026 23.6082 0.364557 23.5514 0.422133C20.4197 3.61259 17.2875 6.80305 14.1558 9.99351C13.4808 10.6813 12.6872 10.9498 11.775 10.6093C11.4503 10.4879 11.1324 10.272 10.8854 10.0223C7.72009 6.81807 4.56827 3.6007 1.41399 0.386461C1.36875 0.34015 1.3284 0.289458 1.2428 0.192455H1.24219Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6347 17.8614C23.362 17.8996 23.0062 17.9922 22.6497 17.9928C17.9474 18.0028 13.2456 17.9991 8.54325 17.9991C6.46874 17.9991 4.39422 18.006 2.3197 17.9922C1.97792 17.9903 1.63614 17.9008 1.33594 17.857C3.83844 15.2461 6.322 12.6545 8.8245 10.043C9.1834 10.4122 9.50928 10.7464 9.83456 11.0818C10.4185 11.6839 11.1081 12.0807 11.9354 12.2039C13.182 12.3898 14.2453 12.0056 15.1385 11.1094C15.4754 10.7721 15.8038 10.426 16.1639 10.0549C18.6609 12.6633 21.1451 15.2592 23.6341 17.8602L23.6347 17.8614Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7627 16.7324C22.2584 14.1177 19.7767 11.5268 17.3555 8.99911C19.7773 6.47077 22.2584 3.88048 24.7591 1.26953C24.9529 1.65316 25.0018 2.00738 25.0012 2.37599C24.9993 4.59204 24.9999 6.80809 24.9999 9.02351C24.9999 11.2389 24.9987 13.4218 25.0012 15.621C25.0012 15.9902 24.948 16.3432 24.7621 16.7312L24.7627 16.7324Z",
    fill: "#20996B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6341_7032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconshare);
export default __webpack_public_path__ + "static/media/emailIconshare.dd1fbd7983d9c9444c2b89bd2c9745d6.svg";
export { ForwardRef as ReactComponent };